import { camelCase } from 'lodash-es';
import { useTranslation } from 'next-i18next/pages';
import { useEffect, useState } from 'react';

import { JobTitleEnum } from '@pflegia/types/api/job-title/job-titles.enum';
import { PaginationSortField } from '@pflegia/types/common/job-position/pagination-sort-field';
import { useGetActiveScreenBreakpoint } from '@pflegia/ui/hooks/use-get-active-screen-breakpoint';
import { useJobListSortStore } from '@pflegia/ui/hooks/use-sort';
import { JOBS } from '@pflegia/ui/pflegia/constants/routes';
import Button from '@pflegia/ui/shared/button';
import { normalizeJobsParams } from '@pflegia/util/common/normalize-jobs-params';

import deJobTitles from '@public/locales/de/jobTitles.json';

import ClusterButton from '@shared/components/cluster-button/ClusterButton';
import {
  POSITION_CLUSTER_CHIPS,
  POSITION_CLUSTER_CHIPS_EXPANDED,
  POSITION_CLUSTER_CHIPS_MOBILE,
  POSITION_CLUSTER_CHIPS_MOBILE_EXPANDED,
} from '@shared/constants/homepage-clusters';

const ChipsVariant = () => {
  const { t } = useTranslation('widgets', { keyPrefix: 'positionCluster' });
  const { setSort } = useJobListSortStore();
  const { isMobile } = useGetActiveScreenBreakpoint();

  const [isExpanded, setIsExpanded] = useState(false);
  const [chipsToDisplay, setChipsToDisplay] = useState<JobTitleEnum[]>([]);

  useEffect(() => {
    const isMobileDisplay = isMobile ?? false;
    const baseChips = isMobileDisplay ? POSITION_CLUSTER_CHIPS_MOBILE : POSITION_CLUSTER_CHIPS;
    const expandedChips = isMobileDisplay ? POSITION_CLUSTER_CHIPS_MOBILE_EXPANDED : POSITION_CLUSTER_CHIPS_EXPANDED;

    setChipsToDisplay(isExpanded ? [...baseChips, ...expandedChips] : baseChips);
  }, [isExpanded, isMobile]);

  const translateJobTitle = (jobPosition: JobTitleEnum) => {
    const jobTitleKey = camelCase(jobPosition) as keyof typeof deJobTitles;
    return deJobTitles[jobTitleKey] ?? jobPosition;
  };

  return (
    <div className='flex flex-col items-center'>
      <div className='flex flex-wrap justify-center'>
        {chipsToDisplay.map(jobPosition => (
          <ClusterButton
            key={jobPosition}
            label={translateJobTitle(jobPosition)}
            href={`${JOBS}/${normalizeJobsParams(translateJobTitle(jobPosition))}`}
            onClick={() => setSort(PaginationSortField.Salary)}
            testId={`position-${jobPosition}`}
          />
        ))}
      </div>
      <Button
        label={isExpanded ? t('showLessButton') : t('showMoreButton')}
        colorScheme='secondary'
        className='mt-5'
        onClick={() => setIsExpanded(!isExpanded)}
      />
    </div>
  );
};

export default ChipsVariant;
